<template slot-scope="scope">
  <!-- 技能输入弹窗 -->
      <dialogModel
        title="技能"
        :visible.sync="dialogSkill"
        @handleClose="handleCloseSkill"
        @handleOk="handleSkill"
      >
        <div class="main-body">
          <div class="Add-skill">
            <p>输入技能名称：</p>
            <div>
              <el-input v-model="input" placeholder="请输入"></el-input>
            </div>
            <p class="Add-but" @click="handelAddSkill">添加</p>
          </div>
          <div class="haveSkill">
            <div class="firm-clickable"
              v-for="(item, index) in dataArr"
              :key="index"
              @click="handelSelect(item)"
              :style="
                item.Select == true ? 'color:#ffffff;background: #409eff ;' : ''
              "
            >
              {{ item.skillName }}
              <p class="firm-clickable" @click.stop="handelDele(item, index)"></p>
            </div>
          </div>
        </div>
      </dialogModel>
</template>

<script>
import {
  selectSkill, //获取个人自定义技能列表
  addUserCustomSkill, //新增自定义技能
  deleteUserCustomSkill, //删除自定义技能
} from "../../../../../../assets/api/CenterJane";
export default {
  props: {
    dialogSkill: {},
    skillNameList: {},
  },
  components: {},
  data() {
    return {
      input: "",
      dataArr: [], // 数组
      dataArrSelect: [], //
    };
  },
  watch: {
    // 监听
    dialogSkill: {
      handler(newSs, old) {
        if (newSs == true) {
          this.selectSkill(); // 获取自定义技能列表
          this.dataArrSelect = JSON.parse(
            JSON.stringify(this.skillNameList || [])
          );
          // for (var i in newSs) {
          //   this.dataArrSelect = newSs;
          // }
        } else {
          this.input = "";
        }
      },
    },
  },
  computed: {},
  created() {},
  methods: {
    // 选择技能
    handelSelect(item) {
      if (item.Select == true) {
        item.Select = false;

        for (var i in this.dataArrSelect) {
          if (item.skillName == this.dataArrSelect[i]) {
            this.dataArrSelect.splice(i, 1);
          }
        }
      } else {
        // 未选中
        item.Select = true;
        this.dataArrSelect[this.dataArrSelect.length++] = item.skillName;
      }
      this.$forceUpdate();
    },
    // 获取自定义技能列表
    selectSkill() {
      selectSkill({}).then((res) => {
        this.dataArr = res.data;
        for (var i in this.dataArr) {
          this.dataArr[i].Select = false;
          for (var k in this.dataArrSelect) {
            if (this.dataArr[i].skillName == this.dataArrSelect[k]) {
              this.dataArr[i].Select = true;
            }
          }
        }
      });
    },
    // 删除 已添加的技能
    handelDele(item, index) {
      var data = {
        data: {
          id: item.id,
          skillName: item.skillName,
        },
      };
      deleteUserCustomSkill(data).then((res) => {
        if (res.code == 0) {
          for (var i in this.dataArrSelect) {
            if (item.skillName == this.dataArrSelect[i]) {
              this.dataArrSelect.splice(i, 1);
            }
          }
          this.selectSkill();
        }
        console.log(this.dataArrSelect , 'this.dataArrSelect')
      });
      // this.dataArr.splice(index, 1);
    },
    // 添加技能
    handelAddSkill() {
      if (this.input != "") {
        var data = {
          data: this.input,
        };
        addUserCustomSkill(data).then((res) => {
          if (res.code == 0) {
            this.selectSkill();
            this.input = "";
          }
        });
        // this.dataArr.push(this.input);
        // this.input = "";
      }
    },
    // 取消 关闭弹窗
    handleCloseSkill() {
      this.$emit("handleCloseSkill");
      this.dataArr = [];
    },
    // 确认
    handleSkill() {
      this.$emit(
        "handleSkill",
        this.dataArrSelect,
        this.dataArrSelect.toString()
      );
      this.dataArrSelect = [];
      this.dataArr = [];
    },
  },
};
</script>

<style scoped lang="less">
/deep/.el-button {
  width: 120px !important;
  height: 40px !important;
}
.el-button--primary {
  background: #409eff ;
  border: 1px solid #409eff ;
}

// 输入框
/deep/.el-textarea__inner {
  border: 1px solid #409eff ;
  margin-top: 10px;
}
// 弹窗标题
.dialog-title {
  width: 100%;
  height: 60px;
  .off {
    width: 100%;
    height: 28px;
    display: flex;
    justify-content: flex-end;
    div {
      width: 18px;
      height: 18px;
      background-image: url("../../../../../../assets/imgs/guanbi.svg");
      background-size: 100% 100%;
      margin-top: 15px;
    }
  }
  p {
    width: 100%;
    height: 28px;
    line-height: 28px;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #409eff ;
    text-align: center;
    font-weight: 400;
  }
}
// 弹窗主体内容
.main-body {
  .Add-skill {
    display: flex;
    align-items: center;
    > p:first-child {
      flex-shrink: 0;
      margin: 0 10px 0 0;
      white-space: nowrap;
      line-height: 35px;
      font-size: 14px;
      color: #333333;
    }
    > div {
      width: 300px;
      height: 35px;
      flex-shrink: 0;
    }
    /deep/ .el-input__inner {
      height: 35px;
      line-height: 35px;
      border: 1px solid #409eff ;
      border-radius: 5px;
    }
    .Add-but {
      width: 80px;
      height: 35px;
      line-height: 35px;
      background: #409eff ;
      border-radius: 5px;
      margin: 0 0 0 20px;
      text-align: center;
      color: #ffffff;
      font-size: 14px;
      flex-shrink: 0;
      cursor: pointer;
    }
  }
  .haveSkill {
    width: 100%;
    min-height: 50px;
    padding: 20px 0px 20px 0px;
    display: flex;
    flex-wrap: wrap;
    div {
      padding-left: 8px;
      padding-right: 8px;
      min-width: 70px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      border-radius: 5px;
      font-size: 12px;
      position: relative;
      background: #c4c4c4;
      // border: 1px solid #409eff ;
      // background: #409eff ;
      // color: #ffffff;
      margin-right: 10px;
      margin-bottom: 10px;
      p {
        width: 15px;
        height: 15px;
        border-radius: 50%;
        position: absolute;
        right: -10px;
        top: -10px;
        background-image: url("../../../../../../assets/imgs/guanbi@3x.svg");
        background-size: 100% 100%;
      }
    }
  }
}
</style>
